import { Box, Stack } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useCallback } from 'react'

import { clearCloakedOrgPath } from '~/layouts/components/orgHierarchy/cloakSessionStorage'
import { useCloakingInfo, useRevertToPreviousOrganization } from '~/store/slices/currentOrg'

import { BannerBar, BannerButton, BannerTypography } from './components'

export default function CloakingBanner() {
  const t = useTranslations('layouts.banners')
  const { isCloaking, cloakedOrgs } = useCloakingInfo()
  const popOrganization = useRevertToPreviousOrganization()

  // Legacy Return does not go through useOrgContext persist — drop the tab
  // restore key so a later hierarchy-bar session cannot reopen this cloak.
  const handleReturn = useCallback(() => {
    clearCloakedOrgPath()
    popOrganization()
  }, [popOrganization])

  if (!isCloaking) return null

  const name = cloakedOrgs.at(-1)?.name
  const parentName = cloakedOrgs.at(-2)?.name

  return (
    <BannerBar backgroundColor="primary.main">
      <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center" spacing={6}>
        <Box role="status">
          <BannerTypography color="white">
            {t.rich('cloaking_signedInAs', { org: name ?? '', b: (chunks) => <b>{chunks}</b> })}
          </BannerTypography>{' '}
        </Box>

        <BannerButton darkBackground onClick={handleReturn}>
          {t('cloaking_returnTo', { org: parentName ?? '' })}
        </BannerButton>
      </Stack>
    </BannerBar>
  )
}
